"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _containerImpl = _interopRequireDefault(require("./container-impl"));

var _api = require("./api");

var _excluded = ["component"];

var Container = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _props$component = props.component,
      component = _props$component === void 0 ? 'div' : _props$component,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_containerImpl.default, (0, _extends2.default)({}, otherProps, {
    component: component,
    ref: ref
  }));
});

Container.displayName = 'Container';
Container.defaultProps = _api.defaultProps;
Container.propTypes = _api.propTypes;
var _default = Container;
exports.default = _default;